import React, { useEffect, useState } from 'react';
import type SwiperInstance from 'swiper';
import { useSwiper } from 'swiper/react';

import { Button, DownloadIcon } from '@motorway/mw-highway-code';

import { useGalleryData } from '../Gallery.utils';

import { DamageLocation } from './DamageLocation';
import type { GalleryImageWithTitle } from './MainGallery';

import styles from './SlideInfo.module.scss';

export interface SlideInfoEvents {
	onDamageLocationView?: (image: GalleryImageWithTitle) => void;
	onDownloadClick?: (image: GalleryImageWithTitle) => void;
}

interface SlideInfoProps {
	events?: SlideInfoEvents;
	showDownloadImageButtons?: boolean;
}

export const SlideInfo: React.FC<SlideInfoProps> = ({ events, showDownloadImageButtons }) => {
	const { images } = useGalleryData();
	const swiper = useSwiper();
	const [activeIndex, setActiveIndex] = useState(0);

	useEffect(() => {
		swiper.on('activeIndexChange', (sw: SwiperInstance) => setActiveIndex(sw.activeIndex));
		return () => {
			swiper.off('activeIndexChange');
		};
	}, [swiper]);

	const photo = images?.[activeIndex];

	if (!photo) {
		return null;
	}

	return (
		<>
			{'damageMeta' in photo && photo.damageMeta && (
				<DamageLocation key={photo.id} data={photo.damageMeta} onView={() => events?.onDamageLocationView?.(photo)} />
			)}
			<div className={styles.title} data-testid="gallery-slide-title">
				{showDownloadImageButtons && photo.title ? (
					<div className={styles.buttonContainer}>
						<Button
							icon={DownloadIcon}
							label={photo.title}
							onClick={() => events?.onDownloadClick?.(photo)}
							size="small"
							variant="tertiary"
						/>
					</div>
				) : (
					photo.title
				)}
			</div>
		</>
	);
};
